import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    const idRegex = /program_dashboard\[charts_attributes]\[(\d+)\]\[chart_type\]/;
    const newId = $(this.element).closest(".nested-fields").find(".chart-type-select").attr("name").match(idRegex)[1]
    this.element.id = `demographic-fields-form-${newId}`
    $(this.element).find(".add-demographic-field").attr("href", $(this.element).find(".add-demographic-field").attr("href").replace(/new_chart/g, newId))
  }
}
